









import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { ImageClipper } from '@/utils/imageClipper'
import { ToolbarModule } from '@/store/modules/toolbar'
import { PaintingByNumbersModule } from '../../../store/modules/paintingByNumbers';

@Component({
    name: 'painting-by-numbers-editor-error'
})
export default class PaintingByNumbersEditorError extends Vue {

    @Prop() private usageName!: string

    get error() {
        let hasError = false
        if(ToolbarModule.errorKeys.length !== 0){
            if (ToolbarModule.errorKeys.includes(this.usageName)) {
                hasError = true
            }
        }
        return hasError
    }

    get imageEditorWidth() {
        return PaintingByNumbersModule.imageEditorWidth
    }
    
    get imageEditorHeight() {
        return PaintingByNumbersModule.imageEditorHeight
    }
}
